'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cx } from '../../../internal/cx.js';
import { setRefs, useDismissible } from '../../../internal/dismissible.js';
import { CloseGlyph, ErrorGlyph, InfoGlyph, SuccessGlyph, WarningGlyph, } from '../../../internal/icons.js';
import { IconButton } from '../../actions/button/index.js';
const toneIcon = {
    neutral: _jsx(InfoGlyph, {}),
    info: _jsx(InfoGlyph, {}),
    success: _jsx(SuccessGlyph, {}),
    warning: _jsx(WarningGlyph, {}),
    danger: _jsx(ErrorGlyph, {}),
};
/**
 * A one-line message attached to the thing it is about: a form, a card, a
 * row or a panel. Smaller than Alert, with no body block: icon, optional bold
 * lead-in, one sentence and at most one action.
 */
export const InlineNotice = forwardRef(function InlineNotice({ tone = 'info', variant = 'subtle', title, icon, action, live, dismissible, onDismiss, open, defaultOpen, dismissLabel = 'Dismiss', className, children, ...rest }, ref) {
    const { shown, dismiss, node } = useDismissible({ open, defaultOpen, onDismiss });
    if (!shown)
        return null;
    const politeness = live === true ? (tone === 'danger' ? 'assertive' : 'polite') : live || undefined;
    const role = politeness === 'assertive' ? 'alert' : politeness === 'polite' ? 'status' : undefined;
    const glyph = icon === undefined ? toneIcon[tone] : icon;
    return (_jsxs("div", { ref: (el) => setRefs(el, ref, node), ...rest, className: cx('mn-inline-notice', className), "data-tone": tone, "data-variant": variant, children: [glyph ? (_jsx("span", { className: "mn-inline-notice__icon", "aria-hidden": true, children: glyph })) : null, _jsxs("p", { className: "mn-inline-notice__message", role: role, children: [title ? _jsx("strong", { className: "mn-inline-notice__title", children: title }) : null, title && children ? ' ' : null, children] }), action ? _jsx("span", { className: "mn-inline-notice__action", children: action }) : null, dismissible || onDismiss ? (_jsx(IconButton, { className: "mn-inline-notice__dismiss", size: "xs", label: dismissLabel, icon: _jsx(CloseGlyph, {}), onClick: dismiss })) : null] }));
});
//# sourceMappingURL=inline-notice.js.map